import React, { useEffect } from 'react';
import DocumentLibrary from './DocumentLibrary';
import { useDocumentStorageCategories } from '../hooks/useDocumentStorageCategories';

export default function DocumentStorage() {
  const { categories, loading, initializeDefaultCategories } = useDocumentStorageCategories();

  // Auto-initialize categories on first load if none exist
  useEffect(() => {
    if (!loading && categories.length === 0) {
      console.log('No categories found, initializing defaults...');
      initializeDefaultCategories().catch(err => {
        console.error('Failed to initialize categories:', err);
      });
    }
  }, [loading, categories.length, initializeDefaultCategories]);

  return <DocumentLibrary />;
}
